import React from 'react';
import { useIntl } from 'react-intl';

import ActionButton from 'components/widgets/ActionButton/ActionButton';
import { useParentalControlContext } from 'context/parentalControlContext/parentalControlContext';

import { FULL_COMPONENT_NAME, typePin } from '../../constans';

import styles from './PurchaseProtection.module.scss';

const PurchaseProtection = () => {
  const { onChangePin } = useParentalControlContext();
  const intl = useIntl();
  const nameLabel = intl.formatMessage({ id: `${FULL_COMPONENT_NAME}.textProtection`, defaultMessage: 'Purchase Protection' });
  const buttonLabel = intl.formatMessage({ id: `${FULL_COMPONENT_NAME}.buttonChangePurchase`, defaultMessage: 'Change Purchase PIN' });

  return (
    <>
      <p className={styles.name}>{ nameLabel }</p>
      <div className={styles.block}>
        <ActionButton title={buttonLabel} onClick={onChangePin(typePin.purchase)} />
      </div>
    </>
  );
};

export default React.memo(PurchaseProtection);
